import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
export default class Hero {
    constructor(el) {
        this.el = el;
        this.setVars();
        this.init();
    }

    setVars() {
        this.sectionlink = this.el.dataset.section;
        this.section = document.getElementById(this.sectionlink);
        // heading, copy, logo, nav
    }

    init() {
        console.log(this.section);
        if (this.section) {
            this.el.addEventListener("click", this.handleClick);
        }
    }

    handleClick = event => {
        event.preventDefault();
        gsap.to(window, {
            duration: 0.8,
            scrollTo: this.section,
            ease: "Power3.easeOut",
        });
    };
}
